import { HAS_CATEGORY } from '@modules/charts/constants';
import { Category } from '@modules/common/types';

interface GetIdOrLabelFromCategoryOptions {
  key: string;
  category?: Category;
}

export const getIdOrLabelFromCategory = ({
  key,
  category,
}: GetIdOrLabelFromCategoryOptions) => {
  return category ? `${key}${HAS_CATEGORY}${category}` : key;
};
